import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';

@Component({
    selector: 'app-heartland-pay-dialog',
    templateUrl: './heartland-pay-dialog.component.html',
    styleUrls: ['./heartland-pay-dialog.component.scss'],
    standalone: false
})
export class HeartlandPayDialogComponent implements OnInit {
	hps: any;
	status: any = {}

	constructor(
		private zone: NgZone,
		public appService: AppService,
		public entityService: EntityService,
		public dialogRef: MatDialogRef<HeartlandPayDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
		setTimeout(() => { this.initHeartland();}, 200);
	}

	ngOnDestroy() {
		if (this.hps) {
			try {
				this.hps.destroy();
			} catch (e) {

			}
		}			
	}

	wasHeartland: boolean = false;
	initHeartland() {
		if (this.wasHeartland) return;
		this.wasHeartland = true;
		let that = this;
		that.hps = new window["Heartland"]["HPS"]({
			publicKey: this.data.merchantNumber,
			type: 'iframe',
			// Configure the iframe fields to tell the library where
			// the iframe should be inserted into the DOM and some
			// basic options
			fields: {
				cardNumber: {
					target: 'iframesCardNumber',
					placeholder: '•••• •••• •••• ••••'
				},
				cardExpiration: {
					target: 'iframesCardExpiration',
					placeholder: 'MM / YYYY'
				},
				cardCvv: {
					target: 'iframesCardCvv',
					placeholder: 'CVV'
				},
				submit: {
					value: 'PAY',
					target: 'iframesSubmit'
				}
			},
			// Collection of CSS to inject into the iframes.
			// These properties can match the site's styles
			// to create a seamless experience.
			style: {
				'input': {
					'background': '#fff',
					'border': '1px solid',
					'border-color': '#bbb3b9 #c7c1c6 #c7c1c6',
					'box-sizing': 'border-box',
					'font-family': 'serif',
					'font-size': '16px',
					'line-height': '1',
					'margin': '0 .5em 0 0',
					'max-width': '100%',
					'outline': '0',
					'padding': '0.5278em',
					'vertical-align': 'baseline',
					'height': '50px',
					'width': '100% !important'
				},
				'#heartland-field': {
					'font-family': 'sans-serif',
					'box-sizing': 'border-box',
					'display': 'block',
					'height': '50px',
					'padding': '6px 12px',
					'font-size': '14px',
					'line-height': '1.42857143',
					'color': '#555',
					'background-color': '#fff',
					'border': '1px solid #ccc',
					'border-radius': '0px',
					'-webkit-box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
					'box-shadow': 'inset 0 1px 1px rgba(0,0,0,.075)',
					'-webkit-transition': 'border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s',
					'-o-transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
					'transition': 'border-color ease-in-out .15s,box-shadow ease-in-out .15s',
					'width': '100%'
				},
				'#heartland-field[name=submit]': {
					'background-color': '#36b46e',
					'font-family': 'sans-serif',
					'text-transform': 'uppercase',
					'color': '#ffffff',
					'border': '0px solid transparent',
					'font-size': '20px',
				},
				'#heartland-field[name=submit]:focus': {
					'color': '#ffffff',
					'background-color': '#258851',
					'outline': 'none'
				},
				'#heartland-field[name=submit]:hover': {
					'background-color': '#258851'
				},
				'#heartland-field-wrapper #heartland-field:focus': {
					'border': '1px solid #3989e3',
					'outline': 'none',
					'box-shadow': 'none',
					'height': '50px'
				},
				'heartland-field-wrapper #heartland-field': {
					'height': '50px'
				},
				'input[type=submit]': {
					'box-sizing': 'border-box',
					'display': 'inline-block',
					'padding': '6px 12px',
					'margin-bottom': '0',
					'font-size': '14px',
					'font-weight': '400',
					'line-height': '1.42857143',
					'text-align': 'center',
					'white-space': 'nowrap',
					'vertical-align': 'middle',
					'-ms-touch-action': 'manipulation',
					'touch-action': 'manipulation',
					'cursor': 'pointer',
					'-webkit-user-select': 'none',
					'-moz-user-select': 'none',
					'-ms-user-select': 'none',
					'user-select': 'none',
					'background-image': 'none',
					'border': '1px solid transparent',
					'border-radius': '4px',
					'color': '#fff',
					'background-color': '#337ab7',
					'border-color': '#2e6da4'
				},
				'#heartland-field[placeholder]': {
					'letter-spacing': '3px'
				},
				'#heartland-field[name=cardCvv]': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/cvv1.png?raw=true) no-repeat right',
					'background-size': '63px 40px',
				},
				'input#heartland-field[name=cardNumber]': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-inputcard-blank@2x.png?raw=true) no-repeat right',
					'background-size': '55px 35px'
				},
				'#heartland-field.invalid.card-type-visa': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right',
					'background-size': '83px 88px',
					'background-position-y': '-44px'
				},
				'#heartland-field.valid.card-type-visa': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-visa@2x.png?raw=true) no-repeat right top',
					'background-size': '82px 86px'
				},
				'#heartland-field.invalid.card-type-discover': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
					'background-size': '85px 90px',
					'background-position-y': '-44px'
				},
				'#heartland-field.valid.card-type-discover': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-discover@2x.png?raw=true) no-repeat right',
					'background-size': '85px 90px',
					'background-position-y': '1px'
				},
				'#heartland-field.invalid.card-type-amex': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right',
					'background-size': '50px 90px',
					'background-position-y': '-44px'
				},
				'#heartland-field.valid.card-type-amex': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-savedcards-amex@2x.png?raw=true) no-repeat right top',
					'background-size': '50px 90px'
				},
				'#heartland-field.invalid.card-type-mastercard': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
					'background-size': '62px 105px',
					'background-position-y': '-52px'
				},
				'#heartland-field.valid.card-type-mastercard': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-mastercard.png?raw=true) no-repeat right',
					'background-size': '62px 105px',
					'background-position-y': '-1px'
				},
				'#heartland-field.invalid.card-type-jcb': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right',
					'background-size': '55px 94px',
					'background-position-y': '-44px'
				},
				'#heartland-field.valid.card-type-jcb': {
					'background': 'transparent url(https://github.com/hps/heartland-php/blob/master/examples/end-to-end/assets/images/ss-saved-jcb@2x.png?raw=true) no-repeat right top',
					'background-size': '55px 94px',
					'background-position-y': '2px'
				},
				'input#heartland-field[name=cardNumber]::-ms-clear': {
					'display': 'none'
				}
			},
			// Callback when a token is received from the service
			onTokenSuccess: function (resp) {
				let expMonth = _.trim(resp.exp_month), expYear = _.trim(resp.exp_year);
				if (!expMonth || expMonth.length != 2) expMonth = null;
				else if (!expYear || expYear.length != 4) expYear = null;


				let err = [];
				if (!that.status.cardCvv) err.push("Invalid Card CVV");
				if (!expMonth || !expYear) err.push("Invalid Card Expiration");
				//if (!$scope.status.cardNumber) err.push("Invalid Card Number");
				that.zone.run(_ => {
					if (err.length) {
						return that.appService.alert({ "content": err.join("\n") });
					}
					that.dialogRef.close({ mode: "success", data: { token: resp.token_value, expMonth: expMonth, expYear: expYear } });
				});
			},
			// Callback when an error is received from the service
			onTokenError: function (resp) {
				that.zone.run(_ => {
					return that.appService.alert({ "content": `There was an error: ${resp.error.message}` });
				});				
			},
			onEvent: function (ev) {
				console.log(ev);
				that.status[ev.source] = _.get(ev.classes, '[0]') == "valid";
			}
		});
	}


	applyTimer: any;
	applyCardPoint() {
		clearTimeout(this.applyTimer);
		this.applyTimer = setTimeout(() => {
			let token = this.data.token;
			if (!token) return;
			if (token.validationError) {
				this.appService.alert({ "content": token.validationError });
			}
			if (token.message.length) {
				this.dialogRef.close({ mode: "success", data: { token: token.message, expirey: token.expiry, expiry: token.expiry } });
			}
		}, 1500);
	}

}
